import { createRouter, createWebHistory } from "vue-router";
import Login from "../views/Login.vue";
import TwoFactorAuth from "../views/TwoFactorAuth.vue";
import PasswordChange from "../views/PasswordChange.vue";
import PasswordReset from "../views/PasswordReset.vue";
import UserList from "../views/UserList.vue";
import UserRegister from "../views/UserRegister.vue";
import UserUpdate from "../views/UserUpdate.vue";
import Maintenance from "../views/errors/Maintenance.vue";
import NotFound from "../views/errors/404.vue";
import PointBulkGrantHistory from "../views/PointBulkGrantHistory.vue";
import BulkPointAllocationTargetSearch from "../views/BulkPointAllocationTargetSearch.vue";
import CouponBulkGrantHistory from "../views/CouponBulkGrantHistory.vue";
import CouponGeneration from "../views/CouponGeneration.vue";
import CouponSearch from "../views/CouponSearch.vue";
import CouponTransactionHistory from "../views/CouponTransactionHistory.vue";
import PointTransactionHistory from "../views/PointTransactionHistory.vue";
import SearchPointExchangeMagnification from "../views/SearchPointExchangeMagnification.vue";
import CsvImport from "../views/CsvImport.vue";
import PointGrantResult from "../views/PointGrantResult.vue";
import RegisterPointExchangeMagnification from "../views/RegisterPointExchangeMagnification.vue";
import updatePointExchangeMagnification from "../views/UpdatePointExchangeMagnification.vue";
import deletePointExchangeMagnification from "../views/DeletePointExchangeMagnification.vue";
import SearchPointExcludedProductCode from "../views/SearchPointExcludedProductCode.vue";
import RegisterPointExcludedProductCode from "../views/RegisterPointExcludedProductCode.vue";
import UpdatePointExcludedProductCode from "../views/UpdatePointExcludedProductCode.vue";
import DeletePointExcludedProductCode from "../views/DeletePointExcludedProductCode.vue";
import CouponDetail from "../views/CouponDetail.vue";
import CouponDeleteResult from "../views/CouponDeleteResult.vue";
import BulkCouponAllocationTargetSearch from "../views/BulkCouponAllocationTargetSearch.vue";
import CouponGrantResult from "../views/CouponGrantResult.vue";
const routes = [
    {
        path: "/",
        name: "login",
        component: Login,
    },
    {
        path: "/two-Factor-Auth",
        name: "two-Factor-Auth",
        component: TwoFactorAuth,
    },
    {
        path: "/password-change/:isReturn",
        name: "password-change",
        component: PasswordChange,
    },
    {
        path: "/password-reset",
        name: "password-reset",
        component: PasswordReset,
    },
    {
        path: "/user",
        name: "user",
        component: UserList,
    },
    {
        path: "/user/register",
        name: "user-register",
        component: UserRegister,
    },
    {
        path: "/user/update/:crmUserId",
        name: "user-update",
        component: UserUpdate,
    },
    {
        path: "/maintenance",
        name: "maintenance",
        component: Maintenance,
    },
    {
        path: "/:catchAll(.*)",
        name: "not-found",
        component: NotFound,
    },
    {
        path: "/about",
        name: "about",
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
    },
    //ポイント管理システム画面
    {
        path: "/pointBulkGrantHistory",
        name: "pointBulkGrantHistory",
        component: PointBulkGrantHistory,
    },
    {
        path: "/bulkPointAllocationTargetSearch",
        name: "bulkPointAllocationTargetSearch",
        component: BulkPointAllocationTargetSearch,
    },
    {
        path: "/couponBulkGrantHistory",
        name: "couponBulkGrantHistory",
        component: CouponBulkGrantHistory,
    },
    {
        path: "/couponGeneration",
        name: "couponGeneration",
        component: CouponGeneration,
    },
    {
        path: "/couponSearch",
        name: "couponSearch",
        component: CouponSearch,
    },
    {
        path: "/couponTransactionHistory",
        name: "couponTransactionHistory",
        component: CouponTransactionHistory,
    },
    {
        path: "/couponDetail/:couponCode",
        name: "couponDetail",
        component: CouponDetail,
    },
    {
        path: "/couponDeleteResult/:couponBulkOperationHistoryId",
        name: "couponDeleteResult",
        component: CouponDeleteResult,
    },
    {
        path: "/bulkCouponAllocationTargetSearch/:couponCode",
        name: "bulkCouponAllocationTargetSearch",
        component: BulkCouponAllocationTargetSearch,
    },
    {
        path: "/couponGrantResult/:couponBulkOperationHistoryId",
        name: "couponGrantResult",
        component: CouponGrantResult,
    },
    {
        path: "/pointTransactionHistory",
        name: "pointTransactionHistory",
        component: PointTransactionHistory,
    },
    {
        path: "/searchPointExchangeMagnification",
        name: "searchPointExchangeMagnification",
        component: SearchPointExchangeMagnification,
    },
    {
        path: "/csvImport",
        name: "csvImport",
        component: CsvImport,
    },
    {
        path: "/pointGrantResult/:id",
        name: "pointGrantResult",
        component: PointGrantResult,
    },
    {
        path: "/registerPointExchangeMagnification",
        name: "registerPointExchangeMagnification",
        component: RegisterPointExchangeMagnification,
    },
    {
        path: "/updatePointExchangeMagnification",
        name: "updatePointExchangeMagnification",
        component: updatePointExchangeMagnification,
    },
    {
        path: "/deletePointExchangeMagnification",
        name: "deletePointExchangeMagnification",
        component: deletePointExchangeMagnification,
    },
    {
        path: "/searchPointExcludedProductCode",
        name: "searchPointExcludedProductCode",
        component: SearchPointExcludedProductCode,
    },
    {
        path: "/registerPointExcludedProductCode",
        name: "registerPointExcludedProductCode",
        component: RegisterPointExcludedProductCode,
    },
    {
        path: "/updatePointExcludedProductCode",
        name: "updatePointExcludedProductCode",
        component: UpdatePointExcludedProductCode,
    },
    {
        path: "/deletePointExcludedProductCode",
        name: "deletePointExcludedProductCode",
        component: DeletePointExcludedProductCode,
    },
];
const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});
export { router };
